import { useRoute } from '@react-navigation/native';
import { useGlobalConfig } from 'context/GlobalContext';
import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/index';
import { Platform } from 'utils/platform';

import LivePlayer from './LivePlayer';

import Carousel from 'components/Carousel';
import { DynamicListItemProps } from 'components/Dynamic/ListItem';
import NewCarousel from 'components/NewCarrousel';

type LivePlayerProps = DynamicListItemProps &
  Partial<{
    searchPrograms: CmsApiGenericParams<CmsProgram>;
    _name: string;
  }>;

const LivePlayerOrHeroSelector: FC<LivePlayerProps> = (props) => {
  const route = useRoute();
  const { isKid } = useSelector((state: RootState) => state.profile);
  const { isAuthenticated } = useSelector((state: RootState) => state.auth);
  const { homeLivePlayer } = useGlobalConfig();

  const shouldShowCarousel =
    isKid ||
    Platform.isTV ||
    !isAuthenticated ||
    (Platform.OS === 'ios' && !homeLivePlayer?.ActiveHomeLivePlayerIOS) ||
    (Platform.OS === 'web' && !homeLivePlayer?.ActiveHomeLivePlayerWeb) ||
    (Platform.OS === 'android' && !homeLivePlayer?.ActiveHomeLivePlayerAndroid) ||
    route.name !== 'Home';

  useEffect(() => {
    setTimeout(() => props?.onLoaded?.(), 0);
  }, [props?.searchPrograms]);

  if (shouldShowCarousel) {
    const CarouselComponent = Platform.isTV ? Carousel : NewCarousel;
    return <CarouselComponent searchPrograms={props.searchPrograms} _name="hero" />;
  }

  return <LivePlayer {...props} />;
};

export default LivePlayerOrHeroSelector;
